import { FormControl, FormGroup, FormLabel, Stack, TextField } from "@mui/material";
import { NameValueItem } from "../../api";
import { arrayNotEmpty } from "../utils";

export interface TokensControlProps {
  tokens?: NameValueItem[];
  onChange?: (tokens: NameValueItem[]) => void;
}

export const TokensControl = (props: TokensControlProps) => {
  const { tokens, onChange } = props;

  const getTokens = (length: number) => {
    const items: NameValueItem[] = [];
    if (arrayNotEmpty(tokens)) {
      for (const token of tokens!) {
        items.push(token);
      }
    }
    while (items.length < length) items.push(new NameValueItem()); 
    return items;
  }

  const nameChanged = (index: number, name: string) => {
    const items = getTokens(index + 1);
    items[index].name = name;
    if (onChange) onChange(items);
  }

  const valueChanged = (index: number, value: string) => {
    const items = getTokens(index + 1);
    items[index].value = value;
    if (onChange) onChange(items);
  }


  return (
    <FormControl component="fieldset" sx={{ minWidth: 200 }}>
      <FormLabel component="legend">Tokens</FormLabel>
      <FormGroup>
        {
          (getTokens((tokens?.length ?? 0) + 1)).map((token, index) => (<Stack key={"stack-" + index} spacing={2} direction="row">
            <TextField key={"name-" + index} label="Name" variant="standard" value={token?.name ?? ""} onChange={(e) => nameChanged(index, e.target.value )} />
            <TextField key={"value-" + index} label="Value" variant="standard" value={token?.value ?? ""} onChange={(e) => valueChanged(index, e.target.value )} />
          </Stack>))
        }
      </FormGroup>
    </FormControl>
  );
};
